<template>
  <div class="page page--jbg" style="margin: 105px 0 0 0" ref="page">
    <clp-dialog :show=this.bool.showDialog tablet="white">
      <makc-alert
          v-show="this.str.dialogType === 'server_fail'"
          @closeDialog="closeDialog()"
      />
      <makc-alert
          v-show="this.str.dialogType === 'loader'"
          type="loader"
          title="Пожалуйста, подождите"
      />
      <div v-show="this.str.dialogType === 'payment'" class="payment">
        <div class="payment__title text-b text-lger">Выберите способ оплаты</div>
        <div class="payment__controls">
          <div class="payment__qr">
            <div class="payment__qr-title">Оплатить по&nbsp;QR-коду</div>
            <img class="payment__qr-img" src="@/create/assets/images/qr.png" alt="qr.png">
          </div>
          <div class="payment__btns">
            <button class="payment__btns-btn button button--makc">Оплатить картой</button>
            <button class="payment__btns-btn button button--makc button--makc-blue">Оплатить СБП</button>
            <button @click="closeDialog()" class="payment__btns-btn button button--makc button--makc-unfilled">Назад
            </button>
          </div>
        </div>
      </div>
    </clp-dialog>
    <!-- Превью шире контейнера -->
    <div v-show="isStep('zero')" class="preview-imaged">
      <img class="preview-imaged__image" src="@/create/assets/images/jbg-preview.png" alt="preview-imaged__image">
      <img class="preview-imaged__image-mobile" src="@/create/assets/images/jbg-preview-mobile.png"
           alt="preview-imaged__image-mobile">
      <div class="preview-imaged__content">

        <div class="preview-imaged__text">
          <p class="preview-imaged__text-title text-b text-enorm text-mob-med mb10">Жизнь без&nbsp;границ</p>
          <p class="preview-imaged__text-subtitle text-r text-lger text-mob-mid mb10">Программа страхования&nbsp;здоровья</p>
          <!-- <p class="preview-imaged__text-subtitle text-b text-mid text-mob-tiny">21% скидка по промокоду MLНам21 или по карте москвича/петербуржца</p> -->
        </div>
        <div class="preview-imaged__btns">
          <button @click="changeStep('one')" class="preview-imaged__btns-btn button button--makc">
            Оформить
          </button>
          <button @click="this.$refs.details.scrollIntoView({ behavior: 'smooth'})"
                  class="preview-imaged__btns-btn button button--makc button--makc-unfilled">
            Подробнее
          </button>
        </div>
      </div>
    </div>
    <div class="container container--jbg" ref="details" :class="{'container--jbg-zero': this.isStep('zero'),}">
      <div class="content content--jbg">
        <!-- Степпер -->
        <div class="stepper"
             :class="{'stepper--on-step-zero': isStep('zero'),'stepper--on-step-one': isStep('one'),'stepper--on-step-two': isStep('two'),'stepper--on-step-three': isStep('three'),}"
        >
          <!-- <div @click="changeStep('one')" class="stepper__step stepper__step--first"> -->
          <div class="stepper__step stepper__step--first">
            <div class="stepper__num ">1</div>
            <div class="stepper__title">Расчет</div>
          </div>

          <!-- <div @click="changeStep('two')" class="stepper__step stepper__step--sec"> -->
          <div class="stepper__step stepper__step--sec">
            <div class="stepper__num">2</div>
            <div class="stepper__title">Оформление</div>
          </div>

          <!-- <div @click="changeStep('zero')" class="stepper__step stepper__step--third"> -->
          <div class="stepper__step stepper__step--third">
            <div class="stepper__num">3</div>
            <div class="stepper__title">Оплата</div>
          </div>
        </div>
        <!-- Превью -->
        <div v-show="isStep('zero')">
          <section class="content__section content__section--why section section--makc">
            <h3 class="section__title text-b text-lger text-mob-sm">
              Зачем нужен полис страхования от&nbsp;критических заболеваний?
            </h3>
            <p class="section__descr text-mid text-mob-tiny">
              Куда обратиться для лечения? Сколько это будет стоить? Чаще всего именно эти вопросы возникают у&nbsp;человека,
              столкнувшегося с&nbsp;тяжелым заболеванием, особенно со&nbsp;злокачественным новообразованием. Стратегия
              поведения, которую диктует страх, при столкновении с&nbsp;критическими заболеваниями может привести к&nbsp;негативным
              последствиям.
            </p>
            <div class="section__heading text-b text-med text-mob-tiny">
              Правильная стратегия - защитить себя и своих близких заранее:
            </div>
            <ul class="section__points">
              <li class="section__points-point text-mid text-mob-tiny">регулярно проходить медицинские осмотры</li>
              <li class="section__points-point text-mid text-mob-tiny">оформить защиту на случай диагностирования
                критических заболеваний
              </li>
            </ul>
            <div class="section__heading text-b text-mid text-mob-tiny">
              Это может помочь спасти жизнь и здоровье!
            </div>
          </section>
          <section class="content__section content__section--advantages section section--makc">
            <h3 class="section__title text-b text-lger text-mob-med">
              Преимущества программы
            </h3>
            <div class="cards cards--makc">
              <ul class="cards__list">
                <li class="cards__item">
                  <div class="card card--makc">
                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/icons/doctors.svg">
                    </div>
                    <p class="card__descr text-med text-mob-mini">
                      Второе экспертное медицинское мнение по&nbsp;диагностированному заболеванию
                    </p>
                  </div>
                </li>
                <li class="cards__item">
                  <div class="card card--makc">
                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/icons/hospital.svg">
                    </div>
                    <p class="card__descr text-med text-mob-mini">Подбор клиники и&nbsp;страны лечения, организация
                      медицинской помощи</p>
                  </div>
                </li>
                <li class="cards__item">
                  <div class="card card--makc">
                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/icons/ambulance.svg">
                    </div>
                    <p class="card__descr text-med text-mob-mini">
                      Организация транспортировки в&nbsp;пределах Российской Федерации или за&nbsp;рубежом
                    </p>
                  </div>
                </li>
                <li class="cards__item">
                  <div class="card card--makc">
                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/icons/idcard.svg">
                    </div>
                    <p class="card__descr text-med text-mob-mini">Визовая поддержка (помощь в&nbsp;оформлении визы)</p>
                  </div>
                </li>
                <li class="cards__item">
                  <div class="card card--makc">
                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/icons/building.svg">
                    </div>
                    <p class="card__descr text-med text-mob-mini">Оплата проживания в&nbsp;отеле для Застрахованного и&nbsp;одного
                      сопровождающего</p>
                  </div>
                </li>
                <li class="cards__item">
                  <div class="card card--makc">
                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/icons/truck.svg">
                    </div>
                    <p class="card__descr text-med text-mob-mini">
                      Услуги по&nbsp;репатриации в&nbsp;случае смерти Застрахованного лица
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </section>
          <section class="content__section content__section--countries section section--makc">
            <h3 class="section__title text-b text-lger text-mob-sm">
              Страны лечения*
            </h3>
            <div class="titled-images">
              <ul class="titled-images__list">
                <li class="titled-images__item">
                  <img src="@/create/assets/images/flag-rus.jpg" alt="flag-rus.jpg" class="titled-images__item-img">
                  <div class="titled-images__item-title text-med text-mob-tiny">
                    Россия
                  </div>
                </li>
                <li class="titled-images__item">
                  <img src="@/create/assets/images/flag-ger.jpg" alt="flag-ger.jpg" class="titled-images__item-img">
                  <div class="titled-images__item-title text-med text-mob-tiny">
                    Германия
                  </div>
                </li>
                <li class="titled-images__item">
                  <img src="@/create/assets/images/flag-tur.jpg" alt="flag-tur.jpg" class="titled-images__item-img">
                  <div class="titled-images__item-title text-med text-mob-tiny">
                    Турция
                  </div>
                </li>
                <li class="titled-images__item">
                  <img src="@/create/assets/images/flag-skor.jpg" alt="flag-skor.jpg" class="titled-images__item-img">
                  <div class="titled-images__item-title text-med text-mob-tiny">
                    Южная Корея
                  </div>
                </li>
                <li class="titled-images__item">
                  <img src="@/create/assets/images/flag-uae.jpg" alt="flag-uae.jpg" class="titled-images__item-img">
                  <div class="titled-images__item-title text-med text-mob-tiny">
                    ОАЭ
                  </div>
                </li>
                <li class="titled-images__item">
                  <img src="@/create/assets/images/flag-spa.jpg" alt="flag-spa.jpg" class="titled-images__item-img">
                  <div class="titled-images__item-title text-med text-mob-tiny">
                    Испания
                  </div>
                </li>
                <li class="titled-images__item">
                  <img src="@/create/assets/images/flag-isr.jpg" alt="flag-isr.jpg" class="titled-images__item-img">
                  <div class="titled-images__item-title text-med text-mob-tiny">
                    Израиль
                  </div>
                </li>
              </ul>
            </div>
            <div class="section__remark text-smer text-mob-mini">
              * Страна для лечения определяется по&nbsp;согласованию Страхователя/ Застрахованного лица со Страховщиком
              при&nbsp;наступлении страхового случая с&nbsp;учетом специфики заболевания.
            </div>
          </section>
          <section class="content__section content__section--terms-risks section section--makc">
            <!-- Табы -->
            <div class="clp-tabs">
              <div @click="changeTermsRisksTab('terms')"
                   class="clp-tabs__tab text-b text-mid text-mob-sm"
                   :class="{'clp-tabs__tab--selected': isTermsRisksTab('terms')}"
              >Условия программы
              </div>
              <div @click="changeTermsRisksTab('risks')"
                   class="clp-tabs__tab text-b text-mid text-mob-sm"
                   :class="{'clp-tabs__tab--selected': isTermsRisksTab('risks')}"
              >Страховые риски
              </div>
            </div>
            <div class="table-striped mb30" v-if="isTermsRisksTab('terms')">
              <div class="table-striped__row table-striped__row--stripe">
                <div class="table-striped__row-title">Срок страхования</div>
                <div class="table-striped__row-descr">1&nbsp;год (со&nbsp;дня, следующего за&nbsp;датой заключения
                  договора)
                </div>
              </div>
              <div class="table-striped__row">
                <div class="table-striped__row-title">Возраст страхователя</div>
                <div class="table-striped__row-descr">от 18 лет</div>
              </div>
              <div class="table-striped__row table-striped__row--stripe">
                <div class="table-striped__row-title">Возраст застрахованных</div>
                <div class="table-striped__row-descr">
                  от&nbsp;18&nbsp;до&nbsp;65&nbsp;лет при первичном заключении договора&nbsp;&mdash; для основного
                  застрахованного
                  (до&nbsp;75&nbsp;лет при непрерывном ежегодном перезаключении договора)<br><br>
                  от&nbsp;0&nbsp;до&nbsp;17&nbsp;лет&nbsp;&mdash; для дополнительных застрахованных
                </div>
              </div>
              <div class="table-striped__row">
                <div class="table-striped__row-title">Количество застрахованных</div>
                <div class="table-striped__row-descr">1&nbsp;основной застрахованный +&nbsp;до&nbsp;5 дополнительных
                  застрахованных лиц
                </div>
              </div>
              <div class="table-striped__row table-striped__row--stripe">
                <div class="table-striped__row-title">Период ожидания</div>
                <div class="table-striped__row-descr">180 дней на&nbsp;первый год страхования (при непрерывном
                  перезаключении не&nbsp;применяется)
                </div>
              </div>
              <div class="table-striped__row">
                <div class="table-striped__row-title">Страховая сумма</div>
                <div class="table-striped__row-descr">6&nbsp;000&nbsp;000 рублей или 18&nbsp;000&nbsp;000 рублей</div>
              </div>
              <div class="table-striped__row table-striped__row--stripe">
                <div class="table-striped__row-title">Действие программы</div>
                <div class="table-striped__row-descr">24/7</div>
              </div>
              <div class="table-striped__row">
                <div class="table-striped__row-title">Территория страхования</div>
                <div class="table-striped__row-descr">Весь мир</div>
              </div>
              <div class="table-striped__row table-striped__row--stripe">
                <div class="table-striped__row-title">Периодичность взносов</div>
                <div class="table-striped__row-descr">Единовременно (в&nbsp;день заключения договора)</div>
              </div>
            </div>
            <div class="table-striped mb30" v-if="isTermsRisksTab('risks')">
              <div class="table-striped__row">
                <div class="table-striped__row-title">Основной страховой риск</div>
                <div class="table-striped__row-descr">Лечение критического заболевания</div>
              </div>
              <div class="table-striped__row table-striped__row--stripe">
                <div class="table-striped__row-title">Дополнительные<br>страховые риски и опции</div>
                <div class="table-striped__row-descr">
                  Критическое заболевание (выплата деньгами)<br>
                  Трансплантация костного мозга или органов
                </div>
              </div>
            </div>
            <!-- <div v-show="isTermsRisksTab('risks')" style="height: 401px;"></div> -->
            <div class="section__buttons">
              <button @click="changeStep('one'); this.$refs.page.scrollIntoView()"
                      class="section__buttons-button button button--makc">
                Рассчитать
              </button>
            </div>
          </section>
        </div>
        <!-- Расчет -->
        <div v-show="isStep('one')" style="margin-bottom: 150px;">
          <!-- <p class="content__title text-sb text-giant text-mob-med mb30 mob-mb10">Предварительный расчет</p>    -->
          <section class="content__section content__section--choose section section--makc">
            <h3 class="section__title text-med text-mob-sm">
              Выберите программу&nbsp;страхования
            </h3>
            <div class="largecards largecards--choose">
              <ul class="largecards__list">
                <li class="largecards__item">
                  <div @click="changePackage('regular')" class="largecard largecard--choose"
                       :class="{'largecard--choose-selected': isPackage('regular')}"
                  >
                    <div class="largecard__top">
                      <div class="largecard__title text-b text-lger text-mob-mid">Пакет «Базовый»</div>
                      <div class="largecard__descr text-mid text-mob-tiny">
                        Организация и&nbsp;компенсация расходов на&nbsp;лечение в&nbsp;случае выявления онкологических
                        заболеваний
                      </div>
                    </div>
                    <div class="largecard__bottom">
                      <div class="largecard__bottom-heading text-b text-med text-mob-sm">Страховая сумма:</div>
                      <div class="largecard__bottom-price text-b text-ger text-mob-mid">6&nbsp;000&nbsp;000 рублей</div>
                    </div>
                  </div>
                </li>
                <li class="largecards__item">
                  <div @click="changePackage('extra')" class="largecard largecard--choose"
                       :class="{'largecard--choose-selected': isPackage('extra')}"
                  >
                    <div class="largecard__top">
                      <div class="largecard__title text-b text-lger text-mob-mid">Пакет «Экстра»</div>
                      <div class="largecard__descr text-mid text-mob-tiny">
                        Организация и&nbsp;компенсация расходов на&nbsp;лечение в&nbsp;случае выявления онкологических
                        заболеваний,
                        необходимости проведения кардио- или нейрохирургии
                      </div>
                    </div>
                    <div class="largecard__bottom">
                      <div class="largecard__bottom-heading text-b text-med text-mob-sm">Страховая сумма:</div>
                      <div class="largecard__bottom-price text-b text-ger text-mob-mid">18&nbsp;000&nbsp;000 рублей
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </section>
          <!-- Дополнительные риски и опции - Дата рождения - Количество -->
          <section class="content__section content__section--set section section--makc">
            <h3 class="section__title text-med text-mob-sm">Дополнительные риски и&nbsp;опции:</h3>
            <div class="checkbox checkbox--makc checkbox--makc-giant">
              <input v-model="this.bool.transplant"
                     class="checkbox__input" type="checkbox" name="check_choose_trans" value="check_choose_trans"
                     id="check_choose_trans"
              >
              <label class="checkbox__label" for="check_choose_trans">
                <span class="checkbox__label--icon">
                  <img class="icon" src="@/create/assets/icons/check.svg">
                </span>
                <span class="checkbox__label--text">
                                    <b>Трансплантация</b> (покрытие расходов на&nbsp;трансплантацию костного мозга, если&nbsp;выбран пакет &laquo;Базовый&raquo;<br> 
                                    и трансплантацию костного мозга и&nbsp;органов, если выбран пакет &laquo;Экстра&raquo;)
                                </span>
                <makc-popup tablet="hidden" type="makc_text">
                  <div class="text-sm">
                    Трансплантация костного мозга используется после перенесенного онкологического заболевания
                    в&nbsp;качестве меры защиты от&nbsp;рецидива (по&nbsp;показаниям врача)
                  </div>
                </makc-popup>
              </label>
            </div>
            <div class="checkbox checkbox--makc checkbox--makc-giant mb120 mob-mb50">
              <input v-model="this.bool.compensate"
                     @click.self="this.str.compensateType = this.bool.compensate ? 'none' : '100k'"
                     class="checkbox__input" type="checkbox" name="check_choose_money" value="check_choose_money"
                     id="check_choose_money"
              >
              <label class="checkbox__label" for="check_choose_money">
                <span class="checkbox__label--icon">
                  <img class="icon" src="@/create/assets/icons/check.svg">
                </span>
                <span class="checkbox__label--text"><b>Денежная выплата</b></span>

                <div class="section__radios">
                  <div class="radio">
                    <input v-model="this.str.compensateType" @click.stop="this.bool.compensate = true"
                           type="radio" class="radio__input" name="rad_choose" value="100k" id="rad_choose100"
                    >
                    <label for="rad_choose100" class="radio__label">
                      <span class="radio__icon">
                        <span class="radio__icon--pic"></span>
                      </span>
                      <span class="radio__text">100 000 руб.</span>
                    </label>
                  </div>
                  <div class="radio">
                    <input v-model="this.str.compensateType" @click.stop="this.bool.compensate = true"
                           type="radio" class="radio__input" name="rad_choose" value="300k" id="rad_choose300"
                    >
                    <label for="rad_choose300" class="radio__label">
                      <span class="radio__icon">
                        <span class="radio__icon--pic"></span>
                      </span>
                      <span class="radio__text">300 000 руб.</span>
                    </label>
                  </div>
                </div>
              </label>
            </div>
            <!-- 2 колонки - Дата рождения - Количество -->
            <div class="section__cols">
              <div class="section__cols-col">
                <h3 class="section__heading text-med text-mob-sm">
                  Дата рождения основного&nbsp;застрахованного
                </h3>
                <div class="inputs inputs--makc">
                  <ul class="inputs__list">
                    <li v-if="this.bool.insurerIsInsured"
                        class="inputs__item  inputs__item--1-of-2 inputs__item--tablet-full">
                      <div class="clp-input clp-input--makc">
                        <input v-model="this.obj.insurer.birth_date"
                               class="clp-input__control" type="date" id="calc_birth_date1">
                        <label v-if="this.bool.showErrors && this.arr.errors[0] === 'insurer_birth_date'"
                               class="clp-input__error" for="calc_birth_date1">{{ this.arr.errors[1] }}
                        </label>
                      </div>
                    </li>
                    <li v-else class="inputs__item  inputs__item--1-of-2 inputs__item--tablet-full">
                      <div class="clp-input clp-input--makc">
                        <input v-model="this.obj.primInsured.birth_date"
                               class="clp-input__control" type="date" id="calc_birth_date2">
                        <label v-if="this.bool.showErrors && this.arr.errors[0] === 'primInsured_birth_date'"
                               class="clp-input__error" for="calc_birth_date2">{{ this.arr.errors[1] }}
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="section__cols-col">
                <div class="popup-wrapper" style="display: flex;">
                  <div class="section__heading text-b text-med text-mob-sm">Количество дополнительных застрахованных
                  </div>
                  <makc-popup tablet="hidden" type="makc_text">
                    <div class="text-sm">
                      Застрахованными могут быть только родные дети или официально усыновленные/удочеренные
                      дети Страхователя, а&nbsp;также родные внуки Страхователя
                    </div>
                  </makc-popup>
                </div>
                <!-- Выберите количество -->
                <div class="inputs inputs--makc">
                  <ul class="inputs__list">
                    <li class="inputs__item  inputs__item--1-of-2 inputs__item--tablet-full">
                      <div class="select select--makc">
                        <select v-model="this.str.secInsuredsQuantity"
                                class="select__control" name="ins-children-amount" id="ins-children-amount"
                        >
                          <option selected value="0">0</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </div>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </section>
          <!-- Hе может превышать - Предварительный расчет -->
          <section class="content__section content__section--continue section section--makc">
            <div class="section__indicator">
              <div v-show="this.bool.contractAmountExceeded" class="section__indicator-alert text-mid text-mob-smer">
                Страховая премия по&nbsp;договору страхования не&nbsp;может превышать 40&nbsp;000&nbsp;рублей.
                Пожалуйста, разделите список застрахованных лиц на&nbsp;несколько договоров,
                страховая премия по&nbsp;каждому из&nbsp;которых не&nbsp;будет превышать 40&nbsp;000&nbsp;рублей.
              </div>
              <div class="section__indicator-title text-b text-center text-med text-mob-mid">
                Стоимость полиса
              </div>
              <div class="section__indicator-text" :class="{ 'text-sb': !this.str.contractAmount }">
                {{ this.str.contractAmount ? this.str.contractAmount : '0 ₽' }}
              </div>
            </div>
          </section>
          <section class="content__section content__section--to-ordering section section--makc">
            <button @click="this.bool.showErrors = false; changeStep('two'); this.$refs.page.scrollIntoView()"
                    :disabled="!this.unlockToOrderingBtn()"
                    class="section__button button button--makc button--makc-smaller button--makc-blue">
              Оформить
            </button>
          </section>
        </div>
        <div v-show="isStep('two')" ref="registration">
          <div class="content__title text-sb text-giant text-mob-med mb10">Оформление</div>
          <section class="content__section content__section--insurer section section--makc">
            <h3 class="section__title text-med text-mob-mid mb30 mob-mb20">Страхователь</h3>
            <div class="inputs inputs--makc mb20 mob-mb40">
              <ul class="inputs__list">
                <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                  <div class="clp-input clp-input--makc">
                    <input v-model="this.obj.insurer.surname" class="clp-input__control" type="text"
                           id="insurer_surname" placeholder="Фамилия">
                    <label v-if="this.bool.showErrors && this.arr.errors[0] === 'insurer_surname'"
                           class="clp-input__error" for="insurer_surname">{{ this.arr.errors[1] }}
                    </label>
                  </div>
                </li>
                <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                  <div class="clp-input clp-input--makc">
                    <input v-model="this.obj.insurer.name" class="clp-input__control" type="text" id="insurer_name"
                           placeholder="Имя">
                    <label v-if="this.bool.showErrors && this.arr.errors[0] === 'insurer_name'"
                           class="clp-input__error" for="insurer_name">{{ this.arr.errors[1] }}
                    </label>
                  </div>
                </li>
                <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                  <div class="clp-input clp-input--makc">
                    <input v-model="this.obj.insurer.patronymic" :disabled="this.obj.insurer.noPatronymic"
                           class="clp-input__control" type="text" id="insurer_patronymic"
                           placeholder="Отчество (при наличии)">
                    <label v-if="this.bool.showErrors && this.arr.errors[0] === 'insurer_patronymic'"
                           class="clp-input__error" for="insurer_patronymic">{{ this.arr.errors[1] }}
                    </label>
                  </div>
                </li>
                <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                  <div class="checkbox checkbox--makc mob-mb0">
                    <input v-model="this.obj.insurer.noPatronymic" @click="this.obj.insurer.patronymic = ''"
                           class="checkbox__input" type="checkbox" name="check_no_patr_inser"
                           value="check_no_patr_inser" id="check_no_patr_inser"
                    >
                    <label class="checkbox__label" for="check_no_patr_inser">
                                            <span class="checkbox__label--icon">
                                                <img class="icon" src="@/create/assets/icons/check.svg">
                                            </span>
                      <span class="checkbox__label--text">Отчество отсутствует</span>
                    </label>
                  </div>
                </li>
                <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                  <div class="clp-input clp-input--makc">
                    <label class="clp-input__label" for="insurer_birth_date">Дата рождения</label>
                    <input v-model="this.obj.insurer.birth_date" class="clp-input__control" type="date"
                           id="insurer_birth_date">
                    <label v-if="this.bool.showErrors && this.arr.errors[0] === 'insurer_birth_date'"
                           class="clp-input__error" for="insurer_birth_date">{{ this.arr.errors[1] }}
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <div class="inputs inputs--makc mb20 mob-mb40">
              <ul class="inputs__list">
                <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                  <div class="select select--makc">
                    <select disabled class="select__control" name="doc_type" id="doc_type">
                      <option selected value="1">Паспорт РФ</option>
                    </select>
                  </div>
                </li>
                <li class="inputs__item  inputs__item--hidden inputs__item--tablet-1-of-2"></li>
                <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                  <div class="clp-input clp-input--makc">
                    <input v-model="this.obj.insurer.doc_serial" class="clp-input__control" type="text"
                           id="insurer_doc_serial" placeholder="Серия документа"
                           v-mask="{mask: '####',tokens: {'#': { pattern: /\d/ },},}"
                    >
                    <label v-if="this.bool.showErrors && this.arr.errors[0] === 'insurer_doc_serial'"
                           class="clp-input__error" for="insurer_doc_serial">{{ this.arr.errors[1] }}
                    </label>
                  </div>
                </li>
                <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                  <div class="clp-input clp-input--makc">
                    <input v-model="this.obj.insurer.doc_number" class="clp-input__control" type="text"
                           id="insurer_doc_number" placeholder="Номер документа"
                           v-mask="{mask: '######',tokens: {'#': { pattern: /\d/ },},}"
                    >
                    <label v-if="this.bool.showErrors && this.arr.errors[0] === 'insurer_doc_number'"
                           class="clp-input__error" for="insurer_doc_number">{{ this.arr.errors[1] }}
                    </label>
                  </div>
                </li>
                <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                  <div class="clp-input clp-input--makc" ref="insurer_doc_date">
                    <label class="clp-input__label" for="insurer_doc_date">Дата выдачи</label>
                    <input v-model="this.obj.insurer.doc_date" class="clp-input__control" type="date"
                           id="insurer_doc_date">
                    <label v-if="this.bool.showErrors && this.arr.errors[0] === 'insurer_doc_date'"
                           class="clp-input__error" for="insurer_doc_date">{{ this.arr.errors[1] }}
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <div class="inputs inputs--makc">
              <ul class="inputs__list">
                <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                  <div class="clp-input clp-input--makc">
                    <input v-model="this.obj.insurer.phone" class="clp-input__control" type="text" id="insurer_phone"
                           placeholder="Телефон"
                           v-mask="{
                                                mask: '+7 (FD#) ###-##-##',
                                                tokens: {
                                                    F: {
                                                    pattern: /[3489]/,
                                                    },
                                                    D: {
                                                    pattern: this.obj.insurer.phone[4] == '8' ? /[0-8]/ : /\d/,
                                                    },
                                                    '#': { pattern: /\d/ },
                                                },
                                            }"
                    >
                    <label v-if="this.bool.showErrors && this.arr.errors[0] === 'insurer_phone'"
                           class="clp-input__error" for="insurer_phone">{{ this.arr.errors[1] }}
                    </label>
                  </div>
                </li>
                <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                  <div class="clp-input clp-input--makc">
                    <input v-model="this.obj.insurer.email" class="clp-input__control" type="email" id="insurer_email"
                           placeholder="Электронная почта">
                    <label v-if="this.bool.showErrors && this.arr.errors[0] === 'insurer_email'"
                           class="clp-input__error" for="insurer_email">{{ this.arr.errors[1] }}
                    </label>
                  </div>
                </li>
                <!-- Повторите электронную почту -->
                <!-- <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="clp-input clp-input--makc">
                        <label class="clp-input__label" for="insurer_email_repeat">
                            Повторите электронную почту
                        </label>
                        <input v-model="this.obj.insurer.email_repeat" class="clp-input__control" type="email" id="insurer_email_repeat" placeholder="Повторите электронную почту">
                        <label v-if="this.bool.showErrors && this.arr.errors[0] === 'insurer_email_repeat'" class="clp-input__error" for="insurer_email_repeat">{{ this.arr.errors[1] }}</label>
                    </div>
                </li> -->
              </ul>
            </div>
          </section>
          <!-- Застрахованный -->
          <section class="content__section content__section--insured section section--makc">
            <h3 class="section__title text-med text-mob-mid mb20 mob-mb10">Основной Застрахованный (от&nbsp;18&nbsp;до&nbsp;65&nbsp;лет)</h3>
            <div class="jbg-insured--primary">
              <!-- <div class="section__subtitle text-b text-mid text-mob-sm mb30 mob-mb20">Основное Застрахованное лицо <br>(возраст от 18 до 65 лет)</div> -->
              <div class="section__checkbox checkbox checkbox--makc checkbox--makc-giant mob-mb10">
                <input v-model="this.bool.insurerIsInsured" class="checkbox__input" type="checkbox"
                       name="insurer_insured" value="insurer_insured" id="insurer_insured">
                <label class="checkbox__label" for="insurer_insured">
                  <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg">
                  </span>
                  <span class="checkbox__label--text text-mob-sm">Страхователь является Застрахованным</span>
                </label>
              </div>
              <div v-show="!this.bool.insurerIsInsured">
                <div class="inputs inputs--makc mb20 mob-mb40">
                  <ul class="inputs__list">
                    <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                      <div class="clp-input clp-input--makc">
                        <input v-model="this.obj.primInsured.surname" class="clp-input__control" type="text"
                               id="primInsured_surname" placeholder="Фамилия">
                        <label v-if="this.bool.showErrors && this.arr.errors[0] === 'primInsured_surname'"
                               class="clp-input__error" for="primInsured_surname">{{ this.arr.errors[1] }}</label>
                      </div>
                    </li>
                    <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                      <div class="clp-input clp-input--makc">
                        <input v-model="this.obj.primInsured.name" class="clp-input__control" type="text"
                               id="primInsured_name" placeholder="Имя">
                        <label v-if="this.bool.showErrors && this.arr.errors[0] === 'primInsured_name'"
                               class="clp-input__error" for="primInsured_name">{{ this.arr.errors[1] }}</label>
                      </div>
                    </li>
                    <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                      <div class="clp-input clp-input--makc">
                        <input v-model="this.obj.primInsured.patronymic" :disabled="this.obj.primInsured.noPatronymic"
                               class="clp-input__control" type="text" id="primInsured_patronymic"
                               placeholder="Отчество (при наличии)">
                        <label v-if="this.bool.showErrors && this.arr.errors[0] === 'primInsured_patronymic'"
                               class="clp-input__error" for="primInsured_patronymic">{{ this.arr.errors[1] }}</label>
                      </div>
                    </li>
                    <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                      <div class="checkbox checkbox--makc mob-mb0">
                        <input v-model="this.obj.primInsured.noPatronymic" @click="this.obj.primInsured.patronymic = ''"
                               class="checkbox__input" type="checkbox" name="check_no_patr_insed"
                               value="check_no_patr_insed" id="check_no_patr_insed">
                        <label class="checkbox__label" for="check_no_patr_insed">
                          <span class="checkbox__label--icon">
                            <img class="icon" src="@/create/assets/icons/check.svg">
                          </span>
                          <span class="checkbox__label--text">Отчество отсутствует</span>
                        </label>
                      </div>
                    </li>
                    <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                      <div class="clp-input clp-input--makc">
                        <label class="clp-input__label" for="primInsured_birth_date">Дата рождения</label>
                        <input v-model="this.obj.primInsured.birth_date" class="clp-input__control" type="date"
                               id="primInsured_birth_date">
                        <label v-if="this.bool.showErrors && this.arr.errors[0] === 'primInsured_birth_date'"
                               class="clp-input__error" for="primInsured_birth_date">{{ this.arr.errors[1] }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- Документ -->
                <div class="inputs inputs--makc mb20 mob-mb40">
                  <ul class="inputs__list">
                    <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                      <div class="select select--makc">
                        <select disabled class="select__control" name="insured_doc_type" id="insured_doc_type">
                          <option selected value="1">Паспорт РФ</option>
                        </select>
                      </div>
                    </li>
                    <li class="inputs__item  inputs__item--hidden inputs__item--tablet-1-of-2"></li>
                    <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                      <div class="clp-input clp-input--makc">
                        <input v-model="this.obj.primInsured.doc_serial" class="clp-input__control" type="text"
                               id="primInsured_doc_serial" placeholder="Серия документа"
                               v-mask="{mask: '####',tokens: {'#': { pattern: /\d/ },},}"
                        >
                        <label v-if="this.bool.showErrors && this.arr.errors[0] === 'primInsured_doc_serial'"
                               class="clp-input__error" for="primInsured_doc_serial">{{ this.arr.errors[1] }}</label>
                      </div>
                    </li>
                    <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                      <div class="clp-input clp-input--makc">
                        <input v-model="this.obj.primInsured.doc_number" class="clp-input__control" type="text"
                               id="primInsured_doc_number" placeholder="Номер документа"
                               v-mask="{mask: '######',tokens: {'#': { pattern: /\d/ },},}"
                        >
                        <label v-if="this.bool.showErrors && this.arr.errors[0] === 'primInsured_doc_number'"
                               class="clp-input__error" for="primInsured_doc_number">{{ this.arr.errors[1] }}</label>
                      </div>
                    </li>
                    <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                      <div class="clp-input clp-input--makc">
                        <label class="clp-input__label" for="primInsured_doc_date">Дата выдачи</label>
                        <input v-model="this.obj.primInsured.doc_date" class="clp-input__control" type="date"
                               id="primInsured_doc_date">
                        <label v-if="this.bool.showErrors && this.arr.errors[0] === 'primInsured_doc_date'"
                               class="clp-input__error" for="primInsured_doc_date">{{ this.arr.errors[1] }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- Контакты -->
                <div class="inputs inputs--makc">
                  <ul class="inputs__list">
                    <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                      <div class="clp-input clp-input--makc"> -->
                        <input v-model="this.obj.primInsured.phone" class="clp-input__control" type="text"
                               id="primInsured_phone" placeholder="Телефон"
                               v-mask="{
                                                        mask: '+7 (FD#) ###-##-##',
                                                        tokens: {
                                                            F: {
                                                            pattern: /[3489]/,
                                                            },
                                                            D: {
                                                            pattern: this.obj.primInsured.phone[4] == '8' ? /[0-8]/ : /\d/,
                                                            },
                                                            '#': { pattern: /\d/ },
                                                        },
                                                    }"
                        >
                        <label v-if="this.bool.showErrors && this.arr.errors[0] === 'primInsured_phone'"
                               class="clp-input__error" for="primInsured_phone">{{ this.arr.errors[1] }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <div class="section__buttons mb20">
            <div v-show="parseInt(this.str.secInsuredsQuantity) < 5" class="button--makc-iconed">
              <button
                  @click="this.str.secInsuredsQuantity = (parseInt(this.str.secInsuredsQuantity) + 1).toString()"
                  class="button button__control"
              >+
              </button>
              <div class="button__label">
                Добавить Дополнительного застрахованного
              </div>
            </div>
          </div>
          <section v-for="num of parseInt(this.str.secInsuredsQuantity)"
                   class="content__section content__section--insureds section section--makc">
            <div class="jbg-insured--secondary">
              <div class="section__subtitle text-b text-med text-mob-mid mb30 mob-mb20">Дополнительный Застрахованный
                (от&nbsp;0&nbsp;до&nbsp;17&nbsp;лет)
              </div>
              <div class="inputs inputs--makc mb20 mob-mb40">
                <ul class="inputs__list">
                  <!-- Фамилия -->
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="clp-input clp-input--makc">
                      <!-- <label class="clp-input__label" for="secInsured_surname">Фамилия</label>      -->
                      <input v-model="this.arr.secInsureds[num-1].surname" class="clp-input__control" type="text"
                             id="secInsured_surname" placeholder="Фамилия">
                      <label v-if="this.bool.showErrors && this.arr.errors[0] === 'secInsured_surname'+num"
                             class="clp-input__error" for="secInsured_surname">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="clp-input clp-input--makc">
                      <!-- <label class="clp-input__label" for="secInsured_name">Имя</label>         -->
                      <input v-model="this.arr.secInsureds[num-1].name" class="clp-input__control" type="text"
                             id="secInsured_name" placeholder="Имя">
                      <label v-if="this.bool.showErrors && this.arr.errors[0] === 'secInsured_name'+num"
                             class="clp-input__error" for="secInsured_name">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="clp-input clp-input--makc">
                      <!-- <label class="clp-input__label" for="secInsured_patronymic">Отчество (при наличии)</label>          -->
                      <input v-model="this.arr.secInsureds[num-1].patronymic"
                             :disabled="this.arr.secInsureds[num-1].noPatronymic"
                             class="clp-input__control" type="text" id="secInsured_patronymic"
                             placeholder="Отчество (при наличии)">
                      <label v-if="this.bool.showErrors && this.arr.errors[0] === 'secInsured_patronymic'+num"
                             class="clp-input__error" for="secInsured_patronymic">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="checkbox checkbox--makc mob-mb0">
                      <input
                          v-model="this.arr.secInsureds[num-1].noPatronymic"
                          @click="this.arr.secInsureds[num-1].patronymic = ''"
                          class="checkbox__input" type="checkbox" :name="'secInsured_patronymic'+num"
                          :value="'secInsured_patronymic'+num" :id="'secInsured_patronymic'+num">
                      <label class="checkbox__label" :for="'secInsured_patronymic'+num">
                        <span class="checkbox__label--icon">
                          <img class="icon" src="@/create/assets/icons/check.svg">
                        </span>
                        <span class="checkbox__label--text">Отчество отсутствует</span>
                      </label>
                    </div>
                  </li>
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                    <div class="clp-input clp-input--makc">
                      <label class="clp-input__label" for="secInsured_birth_date">Дата рождения</label>
                      <input v-model="this.arr.secInsureds[num-1].birth_date" class="clp-input__control" type="date"
                             id="secInsured_birth_date">
                      <label v-if="this.bool.showErrors && this.arr.errors[0] === 'secInsured_birth_date'+num "
                             class="clp-input__error" for="secInsured_birth_date">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                </ul>
              </div>
              <!-- Документ -->
              <div class="inputs inputs--makc mb20">
                <ul class="inputs__list">
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="select select--makc">
                      <select v-model="this.arr.secInsureds[num-1].doc_type" class="select__control"
                              name="secInsured_doc_type" id="secInsured_doc_type">
                        <option selected value="none" style="display:none">
                          Тип документа
                        </option>
                        <option :disabled="this.getAge(this.arr.secInsureds[num-1].birth_date) < 14" value="passport">
                          Паспорт РФ
                        </option>
                        <option value="birth_certificate">
                          Свидетельство о рождении
                        </option>
                      </select>
                      <label v-if="this.bool.showErrors && this.arr.errors[0] === 'secInsured_doc_type'+num"
                             class="clp-input__error" for="secInsured_doc_type">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="clp-input clp-input--makc">
                      <input v-model="this.arr.secInsureds[num-1].doc_serial" class="clp-input__control" type="text"
                             id="secInsured_doc_serial" placeholder="Серия документа"
                             v-mask="maskSerial(this.arr.secInsureds[num-1].doc_type)"
                      >
                      <label v-if="this.bool.showErrors && this.arr.errors[0] === 'secInsured_doc_serial'+num"
                             class="clp-input__error" for="secInsured_doc_serial">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="clp-input clp-input--makc">
                      <input v-model="this.arr.secInsureds[num-1].doc_number" class="clp-input__control" type="text"
                             id="secInsured_doc_number" placeholder="Номер документа"
                             v-mask="{mask: '######',tokens: {'#': { pattern: /\d/ },},}"
                      >
                      <label v-if="this.bool.showErrors && this.arr.errors[0] === 'secInsured_doc_number'+num"
                             class="clp-input__error" for="secInsured_doc_number">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                    <div class="clp-input clp-input--makc">
                      <label class="clp-input__label" for="secInsured_doc_date">Дата выдачи</label>
                      <input v-model="this.arr.secInsureds[num-1].doc_date" class="clp-input__control" type="date"
                             id="secInsured_doc_date">
                      <label v-if="this.bool.showErrors && this.arr.errors[0] === 'secInsured_doc_date'+num"
                             class="clp-input__error" for="secInsured_doc_date">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                </ul>
              </div>
              <div v-show="num === parseInt(this.str.secInsuredsQuantity)" class="button--makc-iconed mb10">
                <button @click="this.str.secInsuredsQuantity = (parseInt(this.str.secInsuredsQuantity) - 1).toString()"
                        class="button button__control button__control--minus"
                >&ndash;
                </button>
                <div class="button__label">Удалить Застрахованного</div>
              </div>
            </div>
          </section>

          <!-- Чекбоксы - Соцкарта - Страховая премия - Назад - Продолжить-->
          <section class="content__section content__section--to-payment section section--makc">
            <!-- Чекбоксы -->
            <div class="section__checkboxes checkboxes mb30 mob-mb20">
              <ul class="checkboxes__list">
                <!-- Согласен с Политикой обработки персональных данных -->
                <li class="checkboxes__item">
                  <div class="checkbox checkbox--makc checkbox--makc-giant" :class="{'required': this.bool.showErrors && !this.arr.markedCheckboxes.includes('personal_data')}">
                    <input v-model="this.arr.markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                           value="personal_data" id="checkbox1">
                    <label class="checkbox__label" for="checkbox1">
                      <span class="checkbox__label--icon">
                        <img class="icon" src="@/create/assets/icons/check.svg">
                      </span>
                      <span class="checkbox__label--text">Согласен с
                        <a class="clp-link clp-link--makc" target="_blank"
                           href="https://makclife.ru/o-kompanii/obrabotka-personalnykh-dannykh.php">
                          Политикой обработки персональных данных
                        </a>
                      </span>
                    </label>
                  </div>
                </li>
                <!-- Ознакомился с Ключевым информационным документом -->
                <li class="checkboxes__item">
                  <div class="checkbox checkbox--makc checkbox--makc-giant" :class="{'required': this.bool.showErrors && !this.arr.markedCheckboxes.includes('kid')}">
                    <input v-model="this.arr.markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                           value="kid" id="checkbox2">
                    <label class="checkbox__label" for="checkbox2">
                      <span class="checkbox__label--icon">
                        <img class="icon" src="@/create/assets/icons/check.svg">
                      </span>
                      <span
                          v-show="this.bool.newPolicyAndKidArrived && this.str.kidLink !== '#' && this.arr.errors.length === 0"
                          class="checkbox__label--text">Ознакомился с
                        <a class="clp-link clp-link--makc" target="_blank" :href="this.str.kidLink">Ключевым информационным документом</a>
                      </span>
                      <span
                          v-show="!this.bool.newPolicyAndKidArrived || this.str.kidLink === '#' || this.arr.errors.length > 0"
                          class="checkbox__label--text">
                                                Ознакомился с  
                                                <a class="clp-link clp-link--makc clp-link--makc-fresh-disabled"
                                                   disabled>Ключевым информационным документом</a>
                                            </span>
                    </label>
                  </div>
                </li>
                <li class="checkboxes__item">
                  <div class="checkbox checkbox--makc checkbox--makc-giant" :class="{'required': this.bool.showErrors && !this.arr.markedCheckboxes.includes('policy_terms_ins_rules')}">
                    <input v-model="this.arr.markedCheckboxes"
                           class="checkbox__input" type="checkbox" name="check[]" value="policy_terms_ins_rules"
                           id="checkbox3"
                          >
                    <label class="checkbox__label" for="checkbox3">
                      <span class="checkbox__label--icon">
                        <img class="icon" src="@/create/assets/icons/check.svg">
                      </span>
                      <span class="checkbox__label--text">
                        Ознакомился и согласился с
                        <a v-show="this.unlockPolicyTerms()" class="clp-link clp-link--makc"
                           target="_blank" :href="this.str.policyLink">Условиями полиса</a>
                        <a v-show="!this.unlockPolicyTerms()"
                           class="clp-link clp-link--makc clp-link--makc-fresh-disabled"
                           disabled>Условиями полиса</a> и
                        <a class="clp-link clp-link--makc"
                           target="_blank"
                           href="https://makclife.ru/upload/medialibrary/63f/rule_10_2.pdf">Правилами страхования</a>
                      </span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </section>
          <!-- Соцкарта -->
          <section class="content__section content__section--to-payment section section--makc">
            <SocialCards :socialCardInfo="obj.socialCardInfo" @checker="obj.socialCardInfo.socialCardType = ''" />
          </section>
          <!-- Страховая премия - Назад - Продолжить -->
          <section class="content__section content__section--continue section section--makc">
            <div class="section__indicator">
              <div v-show="this.bool.contractAmountExceeded" class="section__indicator-alert text-mid text-mob-smer">
                Страховая премия по&nbsp;договору страхования не&nbsp;может превышать 40&nbsp;000&nbsp;рублей.
                Пожалуйста, разделите список застрахованных лиц на&nbsp;несколько договоров,
                страховая премия по&nbsp;каждому из&nbsp;которых не&nbsp;будет превышать 40&nbsp;000&nbsp;рублей.
              </div>
              <div class="section__indicator-title text-b text-center text-med text-mob-mid">
                Стоимость полиса
              </div>
              <div class="section__indicator-text" :class="{ 'text-sb': !this.str.contractAmount }">
                {{ this.str.contractAmount ? this.str.contractAmount : '0 ₽' }}
              </div>
            </div>
            <div class="section__buttons section__buttons--create-contract">
              <button @click="changeStep('one'); this.$refs.page.scrollIntoView()"
                      class="section__buttons-button section__button button button--makc button--makc-smaller button--makc-blue">
                Назад
              </button>
              <button @click="demonCreate" :disabled="!this.unlockToPaymentBtn()"
                      class="section__buttons-button section__button button button--makc button--makc-smaller">
                Оплатить
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {ref} from 'vue';
import ClpDialog from '@/create/components/ClpDialog.vue';
import MakcPopup from '@/create/components/MakcPopup.vue';
import SocialCards from '@/create/components/SocialCards.vue';
import MakcAlert from '@/create/components/MakcAlert.vue';
import axios from 'axios';
import {baseURL, localDevelopment, testDevelopment, requestVersion, subdomain} from "@/create/composables/const";

export default {
  components: {ClpDialog, MakcPopup, MakcAlert, SocialCards},
  data() {
    return {
      bool: {
        showDialog: false,
        insurerIsInsured: true,
        transplant: false,
        compensate: false,
        contractAmountExceeded: false,
        fieldsAreValidated: false,
        contractAmountArrived: true,
        newPolicyAndKidArrived: true,
        requestArrived: false,
        calcProcess: false,
        formIsChanged: false,
        showErrors: true,
      },
      str: {
        sessionToken: '',
        dialogType: 'server_fail',
        // dialogType: 'loader',
        // dialogType: 'payment',
        currentStep: 'zero',
        // currentStep: 'one',
        // currentStep: 'two',
        termsRisksTab: 'terms',
        selectedPackage: 'none',
        compensateType: 'none',
        secInsuredsQuantity: '0',
        kidLink: '#',
        policyLink: '#',
        contractAmount: '',
        social_card: '',
      },
      arr: {
        secInsureds: [
          {
            name: '',
            surname: '',
            patronymic: '',
            noPatronymic: false,
            birth_date: '',
            doc_type: 'none',
            doc_serial: '',
            doc_number: '',
            doc_date: '',
            doc_issuer: '',
            doc_issuer_code: '',
            phone: '',
          },
          {
            name: '',
            surname: '',
            patronymic: '',
            noPatronymic: false,
            birth_date: '',
            doc_type: 'none',
            doc_serial: '',
            doc_number: '',
            doc_date: '',
            doc_issuer: '',
            doc_issuer_code: '',
            phone: '',
          },
          {
            name: '',
            surname: '',
            patronymic: '',
            noPatronymic: false,
            birth_date: '',
            doc_type: 'none',
            doc_serial: '',
            doc_number: '',
            doc_date: '',
            doc_issuer: '',
            doc_issuer_code: '',
            phone: '',
          },
          {
            name: '',
            surname: '',
            patronymic: '',
            noPatronymic: false,
            birth_date: '',
            doc_type: 'none',
            doc_serial: '',
            doc_number: '',
            doc_date: '',
            doc_issuer: '',
            doc_issuer_code: '',
            phone: '',
          },
          {
            name: '',
            surname: '',
            patronymic: '',
            noPatronymic: false,
            birth_date: '',
            doc_type: 'none',
            doc_serial: '',
            doc_number: '',
            doc_date: '',
            doc_issuer: '',
            doc_issuer_code: '',
            phone: '',
          },
        ],
        errors: [],
        markedCheckboxes: [],
      },
      obj: {
        insurer: {
          name: '',
          surname: '',
          patronymic: '',
          noPatronymic: false,
          birth_date: '',
          doc_type: '',
          doc_serial: '',
          doc_number: '',
          doc_date: '',
          doc_issuer: '',
          doc_issuer_code: '',
          phone: '',
          email: '',
          email_repeat: '',
        },
        primInsured: {
          name: '',
          surname: '',
          patronymic: '',
          noPatronymic: false,
          birth_date: '',
          doc_type: '',
          doc_serial: '',
          doc_number: '',
          doc_date: '',
          doc_issuer: '',
          doc_issuer_code: '',
          phone: '',
        },
        callform: {
          name: '',
          phone: '',
          city: '',
        },
        socialCardInfo: {},
      },
    };
  },
  methods: {
    requestInterval() {
      setInterval(() => {
        if (this.bool.fieldsAreValidated) {
          if (this.bool.newPolicyAndKidArrived) {
            this.bool.newPolicyAndKidArrived = false;
            setTimeout(() => {
              this.getKidAndPolicy();
            }, 3000);
          }
          this.bool.fieldsAreValidated = false;
        }
      }, 1000);
    },
    async calcAmount() {
      try {
        this.bool.contractAmountArrived = false;

        const variantsId = [{value: this.bool.transplant ? '97' : '96'}, {value: this.str.compensateType === '300k' ? '99' : '98'}];

        const request = {
          sessionToken: this.str.sessionToken,
          format: "json",
          ver: requestVersion,
          object: "contract",
          login: "critical",
          action: "calc",
          agreement: {
            program: "cred_kz",
            ins_calc_amount: this.str.selectedPackage === 'regular' ? '6000000' : '18000000',
            ins_calc_type: '1',
            ins_period: '12M',
            payment_order: '1',
            currency: 'rur',
            menu_id: '11',
            variants_id: variantsId,
            insurer_birth_date: this.obj.insurer.birth_date ? this.reworkDate(this.obj.insurer.birth_date) : '01.01.2000',
            insured_birth_date: this.bool.insurerIsInsured ? this.reworkDate(this.obj.insurer.birth_date) : this.reworkDate(this.obj.primInsured.birth_date),
            insurer_sex: '0',
            insured_sex: '0',
            critical_risk: this.bool.compensate ? 'Y' : 'N',
            discount: this.obj.socialCardInfo.cardInputNumber ? 'Y' : 'N',
            discount_card_type: this.obj.socialCardInfo.socialCardType || '',
            discount_card_series : this.obj.socialCardInfo.cardInputSerial || '',
            discount_card_number: this.obj.socialCardInfo.cardInputNumber || '',
          }
        };

        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.ins_fee || r_data.error.message) {
          if (this.str.secInsuredsQuantity === '0') {
            this.str.contractAmount = this.spaceNumsAddRouble(r_data.ins_fee);
            this.obj.socialCardInfo.discount = r_data.discount  // отображения текста о том, что скидка сработала
            this.bool.contractAmountExceeded = false;
            this.bool.contractAmountArrived = true;
          } else if (this.str.secInsuredsQuantity !== '0') {
            this.calcAmountChild(parseInt(r_data.ins_fee));
          }
        } else if (!r_data.ins_fee) {
          this.str.contractAmount = '0 ₽';
        }
      } catch (e) {
        console.log('Frontend Error - ' + e)
      } finally {
      }
    },
    async calcAmountChild(adultAmount) {
      try {
        const variantsId = [{value: this.bool.transplant ? '97' : '96'}, {value: this.str.compensateType === '300k' ? '99' : '98'}];
        const request = {
          sessionToken: this.str.sessionToken,
          format: "json",
          ver: requestVersion,
          object: "contract",
          login: "critical",
          action: "calc",
          agreement: {
            program: "cred_kz",
            ins_calc_amount: this.str.selectedPackage === 'regular' ? '6000000' : '18000000',
            ins_calc_type: '1',
            ins_period: '1Y',
            payment_order: '1',
            currency: 'rur',
            menu_id: '11',
            variants_id: variantsId,
            insurer_birth_date: this.obj.insurer.birth_date ? this.reworkDate(this.obj.insurer.birth_date) : '01.01.2000',
            insured_birth_date: '01.01.2024',
            insurer_sex: '0',
            insured_sex: '0',
            critical_risk: this.bool.compensate ? 'Y' : 'N',
            discount: this.obj.socialCardInfo.cardInputNumber ? 'Y' : 'N',
            discount_card_type: this.obj.socialCardInfo.socialCardType || '',
            discount_card_series : this.obj.socialCardInfo.cardInputSerial || '',
            discount_card_number: this.obj.socialCardInfo.cardInputNumber || '',
          }
        };

        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.ins_fee) {
          const totalChildrenAmount = parseInt(r_data.ins_fee) * parseInt(this.str.secInsuredsQuantity);
          const totalAmount = adultAmount + totalChildrenAmount;

          this.str.contractAmount = this.spaceNumsAddRouble(totalAmount);

          this.bool.contractAmountExceeded = Math.ceil(parseInt(totalAmount)) > 40000 ? true : false;
          this.bool.contractAmountArrived = true;
        } else if (!r_data.ins_fee) {
          this.str.contractAmount = '0 ₽';
        }
      } catch (e) {
        console.log('Frontend Error - ' + e)
      } finally {
      }
    },
    async getKidAndPolicy() {
      try {
        this.str.kidLink = '#';
        this.str.policyLink = '#';

        const variantsId = [{value: this.bool.transplant ? '97' : '96'}, {value: this.str.compensateType === '300k' ? '99' : '98'}];

        const insuredArr = this.bool.insurerIsInsured ? ['0'] : ['1'];
        for (let item = 0; item < parseInt(this.str.secInsuredsQuantity); item++) {
          insuredArr.push((item + 2).toString())
        }

        const contactsArr = [
          {
            first_name: this.obj.insurer.name,
            middle_name: this.obj.insurer.patronymic,
            last_name: this.obj.insurer.surname,
            birth_date: this.obj.insurer.birth_date,
            phone: this.obj.insurer.phone,
            email: this.obj.insurer.email,
            birth_place: "",
            citizenship: "rf",
            sex: "0",
            documents: ['0'],
          },
          {
            first_name: this.obj.primInsured.name,
            middle_name: this.obj.primInsured.patronymic,
            last_name: this.obj.primInsured.surname,
            birth_date: this.obj.primInsured.birth_date,
            phone: this.obj.primInsured.phone,
            email: this.obj.primInsured.email,
            birth_place: "",
            citizenship: "rf",
            sex: "0",
            documents: ['1'],
          },
        ];

        const documentsArr = [
          {
            type: '1',
            serial: this.obj.insurer.doc_serial,
            number: this.obj.insurer.doc_number,
            date: this.obj.insurer.doc_date,
            auth: this.obj.insurer.doc_issuer,
            auth_code: this.obj.insurer.doc_issuer_code
          },
          {
            type: '1',
            serial: this.bool.insurerIsInsured ? this.obj.insurer.doc_serial : this.obj.primInsured.doc_serial,
            number: this.bool.insurerIsInsured ? this.obj.insurer.doc_number : this.obj.primInsured.doc_number,
            date: this.bool.insurerIsInsured ? this.obj.insurer.doc_date : this.obj.primInsured.doc_date,
            auth: this.bool.insurerIsInsured ? this.obj.insurer.doc_issuer : this.obj.primInsured.doc_issuer,
            auth_code: this.bool.insurerIsInsured ? this.obj.insurer.doc_issuer_code : this.obj.primInsured.doc_issuer_code
          }
        ];

        for (let index = 0; index <= parseInt(this.str.secInsuredsQuantity) - 1; index++) {
          const insuredContact = {
            first_name: this.arr.secInsureds[index].name,
            middle_name: this.arr.secInsureds[index].patronymic,
            last_name: this.arr.secInsureds[index].surname,
            birth_date: this.arr.secInsureds[index].birth_date,
            phone: "",
            email: "",
            birth_place: "",
            citizenship: "rf",
            sex: "0",
            documents: [index + 2],
          }
          const insuredDoc = {
            type: this.arr.secInsureds[index].doc_type === 'passport' ? '1' : '17',
            serial: this.arr.secInsureds[index].doc_serial,
            number: this.arr.secInsureds[index].doc_number,
            date: this.arr.secInsureds[index].doc_date,
            auth: this.arr.secInsureds[index].doc_issuer,
            auth_code: this.arr.secInsureds[index].doc_issuer_code
          }
          contactsArr.push(insuredContact);
          documentsArr.push(insuredDoc);
        }

        const request = {
          sessionToken: this.str.sessionToken,
          action: "get_kid",
          format: "json",
          ver: requestVersion,
          object: "contract",
          login: "critical",
          agreement: {
            program: "cred_kz",
            ins_calc_amount: this.str.selectedPackage === 'regular' ? '6000000' : '18000000',
            ins_calc_type: '1',
            ins_period: "12M",
            payment_order: '0',
            currency: "rur",
            insurer: 0,
            // insured: this.bool.insurerIsInsured ? '0' : '1',
            insured: insuredArr,
            status: 10,
            bank_policy_premium: 0,
            ins_rules: true,
            variants_id: variantsId,
            menu_id: '11',
            insurer_birth_date: this.obj.insurer.birth_date ? this.reworkDate(this.obj.insurer.birth_date) : '01.01.2000',
            insured_birth_date: this.bool.insurerIsInsured ? this.reworkDate(this.obj.insurer.birth_date) : this.reworkDate(this.obj.primInsured.birth_date),
            insurer_sex: '0',
            insured_sex: '0',
            critical_risk: this.bool.compensate ? 'Y' : 'N',
            discount: this.obj.socialCardInfo.cardInputNumber ? 'Y' : 'N',
            discount_card_type: this.obj.socialCardInfo.socialCardType || '',
            discount_card_series : this.obj.socialCardInfo.cardInputSerial || '',
            discount_card_number: this.obj.socialCardInfo.cardInputNumber || '',
          },
          contacts: contactsArr,
          documents: documentsArr,
        };
        if (this.bool.compensate) {
          request.agreement.critical_risk = 'Y'
        }
        this.reworkData(request);
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === 'success') {
          const domain = localDevelopment || testDevelopment ? `https://${subdomain}.makclife.ru` : "https://makclife.ru";
          const urlKid = r_data.kid;
          const urlPolicy = r_data.project;

          this.str.kidLink = domain + urlKid;
          this.str.policyLink = domain + urlPolicy;
        } else {
          this.arr.markedCheckboxes = [];
          console.log('backend error after getKidAndPolicy request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
        this.bool.newPolicyAndKidArrived = true
      }
    },
    async demonCreate() {
      try {
        if (this.arr.errors.length > 0) {
          this.bool.showErrors = true;
          this.$refs.registration.scrollIntoView({behavior: 'smooth'});
          return
        }
        if (this.arr.markedCheckboxes.length !== 3) {
          return this.bool.showErrors = true;
        }

        this.openDialog('loader');

        const variantsId = [{value: this.bool.transplant ? '97' : '96'}, {value: this.str.compensateType === '300k' ? '99' : '98'}];

        const insuredArr = this.bool.insurerIsInsured ? ['0'] : ['1'];
        for (let item = 0; item < parseInt(this.str.secInsuredsQuantity); item++) {
          insuredArr.push((item + 2).toString())
        }

        const contactsArr = [
          {
            first_name: this.obj.insurer.name,
            middle_name: this.obj.insurer.patronymic,
            last_name: this.obj.insurer.surname,
            birth_date: this.obj.insurer.birth_date,
            phone: this.obj.insurer.phone,
            email: this.obj.insurer.email,
            birth_place: "",
            citizenship: "rf",
            sex: "0",
            documents: ['0'],
          },
          { // TODO мрачные костыли, которые мы латаем. В прекрасном будущем сделать без этих странных задваиваний
            first_name: this.obj.primInsured.name,
            middle_name: this.obj.primInsured.patronymic,
            last_name: this.obj.primInsured.surname,
            birth_date: this.obj.primInsured.birth_date,
            phone: this.obj.primInsured.phone,
            email: this.obj.primInsured.email,
            // first_name: this.bool.insurerIsInsured ? this.obj.insurer.name : this.obj.primInsured.name,
            // middle_name: this.bool.insurerIsInsured ? this.obj.insurer.patronymic : this.obj.primInsured.patronymic,
            // last_name: this.bool.insurerIsInsured ? this.obj.insurer.surname : this.obj.primInsured.surname,
            // birth_date: this.bool.insurerIsInsured ? this.obj.insurer.birth_date : this.obj.primInsured.birth_date,
            // phone: this.bool.insurerIsInsured ? this.obj.insurer.phone : this.obj.primInsured.phone,
            // email: this.bool.insurerIsInsured ? this.obj.insurer.email : this.obj.primInsured.email,
            birth_place: "",
            citizenship: "rf",
            sex: "0",
            documents: ['1'],
          }
        ];

        // if (this.bool.insurerIsInsured) {
        //   contactsArr.push({
        //     first_name: this.obj.primInsured.name,
        //     middle_name: this.obj.primInsured.patronymic,
        //     last_name: this.obj.primInsured.surname,
        //     birth_date: this.obj.primInsured.birth_date,
        //     phone: this.obj.primInsured.phone,
        //     email: this.obj.primInsured.email,
        //     birth_place: "",
        //     citizenship: "rf",
        //     sex: "0",
        //     documents: ['1'],
        //   })
        // }

        const documentsArr = [
          {
            type: '1',
            serial: this.obj.insurer.doc_serial,
            number: this.obj.insurer.doc_number,
            date: this.obj.insurer.doc_date,
            auth: this.obj.insurer.doc_issuer,
            auth_code: this.obj.insurer.doc_issuer_code
          },
          { // TODO мрачные костыли, которые мы латаем. В прекрасном будущем сделать без этих странных задваиваний
            type: '1',
            serial: this.bool.insurerIsInsured ? this.obj.insurer.doc_serial : this.obj.primInsured.doc_serial,
            number: this.bool.insurerIsInsured ? this.obj.insurer.doc_number : this.obj.primInsured.doc_number,
            date: this.bool.insurerIsInsured ? this.obj.insurer.doc_date : this.obj.primInsured.doc_date,
            auth: this.bool.insurerIsInsured ? this.obj.insurer.doc_issuer : this.obj.primInsured.doc_issuer,
            auth_code: this.bool.insurerIsInsured ? this.obj.insurer.doc_issuer_code : this.obj.primInsured.doc_issuer_code
          }
        ];

        // if (this.bool.insurerIsInsured) {
        //   documentsArr.push({
        //     type: '1',
        //     serial: this.obj.primInsured.doc_serial,
        //     number: this.obj.primInsured.doc_number,
        //     date: this.obj.primInsured.doc_date,
        //     auth: this.obj.primInsured.doc_issuer,
        //     auth_code: this.obj.primInsured.doc_issuer_code
        //   })
        // }

        for (let index = 0; index <= parseInt(this.str.secInsuredsQuantity) - 1; index++) {
          const insuredContact = {
            first_name: this.arr.secInsureds[index].name,
            middle_name: this.arr.secInsureds[index].patronymic,
            last_name: this.arr.secInsureds[index].surname,
            birth_date: this.arr.secInsureds[index].birth_date,
            phone: "",
            email: "",
            birth_place: "",
            citizenship: "rf",
            sex: "0",
            documents: [index + 2],
          }
          const insuredDoc = {
            type: this.arr.secInsureds[index].doc_type === 'passport' ? '1' : '17',
            serial: this.arr.secInsureds[index].doc_serial,
            number: this.arr.secInsureds[index].doc_number,
            date: this.arr.secInsureds[index].doc_date,
            auth: this.arr.secInsureds[index].doc_issuer,
            auth_code: this.arr.secInsureds[index].doc_issuer_code
          }
          contactsArr.push(insuredContact);
          documentsArr.push(insuredDoc);
        }

        const request = {
          sessionToken: this.str.sessionToken,
          action: "demon_create",
          format: "json",
          ver: requestVersion,
          object: "contract",
          login: "critical",
          // demon_id: '10e1_660e6cf6_1993',///
          agreement: {
            program: "cred_kz",
            ins_calc_amount: this.str.selectedPackage === 'regular' ? '6000000' : '18000000',
            ins_calc_type: '1',
            ins_period: "12M",
            payment_order: '0',
            currency: "rur",
            insurer: 0,
            // insured: this.bool.insurerIsInsured ? '0' : '1',
            insured: insuredArr,
            status: 10,
            bank_policy_premium: 0,
            ins_rules: true,
            variants_id: variantsId,
            menu_id: '11',
            discount: this.obj.socialCardInfo.cardInputNumber ? 'Y' : 'N',
            discount_card_type: this.obj.socialCardInfo.socialCardType || '',
            discount_card_series : this.obj.socialCardInfo.cardInputSerial || '',
            discount_card_number: this.obj.socialCardInfo.cardInputNumber || '',
          },
          contacts: contactsArr,
          documents: documentsArr,
        };
        if (this.bool.compensate) {
          request.agreement.critical_risk = 'Y'
        }
        this.reworkData(request);
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === 'success') {
          window.open(r_data.url.link, '_self');
        } else {
          this.arr.markedCheckboxes = [];
          this.openDialog();
          console.log('backend error after demonCreate request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
        this.closeDialog();
      } finally {
        this.bool.requestArrived = true;
      }
    },

    async errorLogger(errorData) {
      try {
        const request = {
          sessionToken: this.str.sessionToken,
          action: "logger",
          login: "critical",
          data: errorData
        }
        const response = await axios.post(baseURL, request);
        console.log(response.data);
      } catch (e) {
      } finally {
      }
    },
    // работа с данными
    getTodaysDate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      today = yyyy + '-' + mm + '-' + dd;
      return today;
    },
    getAge(dateString) {
      let today = new Date();
      let birthDate = new Date(dateString);

      let age = today.getFullYear() - birthDate.getFullYear();
      let m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    checkDocDate(birthDate, docDate) {
      if ((this.getAge(birthDate) - this.getAge(docDate)) < 14) {
        return false
      } else {
        return true
      }
    },
    spaceNumsAddRouble(nums) {
      return nums.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' ₽';
    },
    reworkData(obj) {
      const reworkDocNumber = (docNumber) => {
        let doc = docNumber.length === 0 ? '555-555' : docNumber;
        const nums = /([0-9])/g;
        return doc.match(nums).join('')
      }

      const reworkPhone = (phoneNumber) => {
        let phone = phoneNumber.length === 0 ? '+7(985)555-55-55' : phoneNumber;
        // let phone = phoneNumber.length === 0 ? this.obj.insurer.phone : phoneNumber;
        const nums = /([0-9]|[+])/g;
        return phone.match(nums).join('')
        // return phoneNumber.match(nums).join('')
      }

      for (let item of obj.contacts) {
        item.birth_date = this.reworkDate(item.birth_date);
        item.phone = reworkPhone(item.phone);
      }

      for (let item of obj.documents) {
        item.number = reworkDocNumber(item.number);
        item.date = this.reworkDate(item.date);
      }
    },
    reworkDate(dateNumber) {
      let date = dateNumber.length === 0 ? '2002-02-24' : dateNumber;
      // let date = dateNumber.length === 0 ? this.obj.insurer.birth_date : dateNumber;
      return date.split("-").reverse().join(".")
      // return dateNumber.split("-").reverse().join(".")
    },
    // валидация
    frontValidate() {
      this.arr.errors = [];
      if (this.str.selectedPackage === 'none') {
        return false
      }
      const cyrillicAndNums = /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()\d]+$/;
      const cyrillic = /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
      const latin = /^[A-z\u00C0-\u00ff\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
      const email = /^[a-zA-Z0-9._-]+@[a-zA-Z_-]+?\.[a-zA-Z]{2,3}$/;
      const passport_serial = /\d\d\d\d/;
      // Предварительный расчет
      if (this.bool.insurerIsInsured) {
        if (!this.obj.insurer.birth_date) {
          this.arr.errors.push('insurer_birth_date');
          this.arr.errors.push('укажите корректную дату рождения');
          return false
        } else if (this.getAge(this.obj.insurer.birth_date) < 18 || this.getAge(this.obj.insurer.birth_date) > 65) {
          this.arr.errors.push('insurer_birth_date');
          this.arr.errors.push('допустимый возраст - от 18 до 65 лет');
          return false
        }
      }
      if (!this.bool.insurerIsInsured) {
        if (!this.obj.primInsured.birth_date) {
          this.arr.errors.push('primInsured_birth_date');
          this.arr.errors.push('укажите корректную дату рождения');
          return false
        } else if (this.getAge(this.obj.primInsured.birth_date) < 18 || this.getAge(this.obj.primInsured.birth_date) > 65) {
          this.arr.errors.push('primInsured_birth_date');
          this.arr.errors.push('допустимый возраст - от 18 до 65 лет');
          return false
        }
      }
      // Страхователь
      // ФИО - Дата рождения
      if (!this.obj.insurer.surname) {
        this.arr.errors.push('insurer_surname');
        this.arr.errors.push('укажите фамилию');
        return false
      } else if (!cyrillic.test(this.obj.insurer.surname)) {
        this.arr.errors.push('insurer_surname');
        this.arr.errors.push('допустимы только символы кириллицы');
        return false
      }
      // Имя
      else if (!this.obj.insurer.name) {
        this.arr.errors.push('insurer_name');
        this.arr.errors.push('укажите имя');
        return false
      } else if (!cyrillic.test(this.obj.insurer.name)) {
        this.arr.errors.push('insurer_name');
        this.arr.errors.push('допустимы только символы кириллицы');
        return false
      } else if (this.obj.insurer.name && this.obj.insurer.name === this.obj.insurer.surname) {
        this.arr.errors.push('insurer_name');
        this.arr.errors.push('одинаковые имя и фамилия недопустимы');
        return false
      }
      // Отчество
      else if (!this.obj.insurer.patronymic && !this.obj.insurer.noPatronymic) {
        this.arr.errors.push('insurer_patronymic');
        this.arr.errors.push('укажите отчество');
        return false
      } else if (this.obj.insurer.patronymic && this.obj.insurer.patronymic === this.obj.insurer.surname) {
        this.arr.errors.push('insurer_patronymic');
        this.arr.errors.push('одинаковые отчество и фамилия недопустимы');
        return false
      } else if (this.obj.insurer.patronymic && this.obj.insurer.patronymic === this.obj.insurer.name) {
        this.arr.errors.push('insurer_patronymic');
        this.arr.errors.push('одинаковые имя и отчество недопустимы');
        return false
      } else if (this.obj.insurer.patronymic && !cyrillic.test(this.obj.insurer.patronymic)) {
        this.arr.errors.push('insurer_patronymic');
        this.arr.errors.push('допустимы только символы кириллицы');
        return false
      }
      // Дата рождения
      else if (!this.bool.insurerIsInsured && !this.obj.insurer.birth_date) {
        this.arr.errors.push('insurer_birth_date');
        this.arr.errors.push('укажите корректную дату рождения');
        return false
      } else if (this.getAge(this.obj.insurer.birth_date) < 18 || this.getAge(this.obj.insurer.birth_date) > 65) {
        this.arr.errors.push('insurer_birth_date');
        this.arr.errors.push('допустимый возраст - от 18 до 65 лет');
        return false
      }
      if (!this.obj.insurer.doc_serial) {
        this.arr.errors.push('insurer_doc_serial');
        this.arr.errors.push('укажите серию паспорта');
        return false
      } else if (this.obj.insurer.doc_serial.length !== 4) {
        this.arr.errors.push('insurer_doc_serial');
        this.arr.errors.push('укажите серию паспорта (4 цифры)');
        return false
      }
      // Hомер
      else if (!this.obj.insurer.doc_number) {
        this.arr.errors.push('insurer_doc_number');
        this.arr.errors.push('укажите номер паспорта');
        return false
      } else if (this.obj.insurer.doc_number.length < 6) {
        this.arr.errors.push('insurer_doc_number');
        this.arr.errors.push('укажите номер паспорта (6 цифр)');
        return false
      }
      // Дата выдачи
      else if (!this.obj.insurer.doc_date) {
        this.arr.errors.push('insurer_doc_date');
        this.arr.errors.push('укажите корректную дату выдачи');
        return false
      } else if (!this.checkDocDate(this.obj.insurer.birth_date, this.obj.insurer.doc_date)) {
        this.arr.errors.push('insurer_doc_date');
        this.arr.errors.push('укажите корректную дату выдачи (с 14 лет)');
        return false
      }
      if (!this.obj.insurer.phone) {
        this.arr.errors.push('insurer_phone');
        this.arr.errors.push('укажите номер телефона');
        return false
      } else if (this.obj.insurer.phone.length < 18) {
        this.arr.errors.push('insurer_phone');
        this.arr.errors.push('укажите номер телефона полностью');
        return false
      }
      // Электронная почта
      else if (!this.obj.insurer.email) {
        this.arr.errors.push('insurer_email');
        this.arr.errors.push('укажите адрес электронной почты');
        return false
      } else if (!email.test(this.obj.insurer.email)) {
        this.arr.errors.push('insurer_email');
        this.arr.errors.push('укажите корректный адрес электронной почты');
        return false
      }
      // Застрахованный
      if (!this.bool.insurerIsInsured) {
        // ФИО - Дата рождения
        if (!this.obj.primInsured.surname) {
          this.arr.errors.push('primInsured_surname');
          this.arr.errors.push('укажите фамилию');
          return false
        } else if (!cyrillic.test(this.obj.primInsured.surname)) {
          this.arr.errors.push('primInsured_surname');
          this.arr.errors.push('допустимы только символы кириллицы');
          return false
        }
        // Имя
        else if (!this.obj.primInsured.name) {
          this.arr.errors.push('primInsured_name');
          this.arr.errors.push('укажите имя');
          return false
        } else if (!cyrillic.test(this.obj.primInsured.name)) {
          this.arr.errors.push('primInsured_name');
          this.arr.errors.push('допустимы только символы кириллицы');
          return false
        } else if (this.obj.primInsured.name && this.obj.primInsured.name === this.obj.primInsured.surname) {
          this.arr.errors.push('primInsured_name');
          this.arr.errors.push('одинаковые имя и фамилия недопустимы');
          return false
        }
        // Отчество
        else if (!this.obj.primInsured.patronymic && !this.obj.primInsured.noPatronymic) {
          this.arr.errors.push('primInsured_patronymic');
          this.arr.errors.push('укажите отчество');
          return false
        } else if (this.obj.primInsured.patronymic && this.obj.primInsured.patronymic === this.obj.primInsured.surname) {
          this.arr.errors.push('primInsured_patronymic');
          this.arr.errors.push('одинаковые отчество и фамилия недопустимы');
          return false
        } else if (this.obj.primInsured.patronymic && this.obj.primInsured.patronymic === this.obj.primInsured.name) {
          this.arr.errors.push('primInsured_patronymic');
          this.arr.errors.push('одинаковые имя и отчество недопустимы');
          return false
        } else if (this.obj.primInsured.patronymic && !cyrillic.test(this.obj.primInsured.patronymic)) {
          this.arr.errors.push('primInsured_patronymic');
          this.arr.errors.push('допустимы только символы кириллицы');
          return false
        }
        // Дата рождения
        else if (!this.obj.primInsured.birth_date) {
          this.arr.errors.push('primInsured_birth_date');
          this.arr.errors.push('укажите корректную дату рождения');
          return false
        } else if (this.getAge(this.obj.primInsured.birth_date) < 18 || this.getAge(this.obj.primInsured.birth_date) > 65) {
          this.arr.errors.push('primInsured_birth_date');
          this.arr.errors.push('допустимый возраст - от 18 до 65 лет');
          return false
        }
        // Документ
        if (!this.obj.primInsured.doc_serial) {
          this.arr.errors.push('primInsured_doc_serial');
          this.arr.errors.push('укажите серию паспорта');
          return false
        } else if (this.obj.primInsured.doc_serial.length !== 4) {
          this.arr.errors.push('primInsured_doc_serial');
          this.arr.errors.push('укажите серию паспорта (4 цифры)');
          return false
        }
        // Hомер
        else if (!this.obj.primInsured.doc_number) {
          this.arr.errors.push('primInsured_doc_number');
          this.arr.errors.push('укажите номер паспорта');
          return false
        } else if (this.obj.primInsured.doc_number.length < 6) {
          this.arr.errors.push('primInsured_doc_number');
          this.arr.errors.push('укажите номер паспорта (6 цифр)');
          return false
        }
        // Дата выдачи
        else if (!this.obj.primInsured.doc_date) {
          this.arr.errors.push('primInsured_doc_date');
          this.arr.errors.push('укажите корректную дату выдачи');
          return false
        } else if (!this.checkDocDate(this.obj.primInsured.birth_date, this.obj.primInsured.doc_date)) {
          this.arr.errors.push('primInsured_doc_date');
          this.arr.errors.push('укажите корректную дату выдачи (с 14 лет)');
          return false
        }
        // Контакты
        if (!this.obj.primInsured.phone) {
          this.arr.errors.push('primInsured_phone');
          this.arr.errors.push('укажите номер телефона');
          return false
        } else if (this.obj.primInsured.phone.length < 18) {
          this.arr.errors.push('primInsured_phone');
          this.arr.errors.push('укажите номер телефона полностью');
          return false
        }
      }
      // Дополнительное Застрахованное лицо
      if (parseInt(this.str.secInsuredsQuantity) > 0) {
        for (let index = 0; index < parseInt(this.str.secInsuredsQuantity); index++) {
          // ФИО - Дата рождения
          if (!this.arr.secInsureds[index].surname) {
            this.arr.errors.push('secInsured_surname' + (index + 1));
            this.arr.errors.push('укажите фамилию');
            return false
          } else if (!cyrillic.test(this.arr.secInsureds[index].surname)) {
            this.arr.errors.push('secInsured_surname' + (index + 1));
            this.arr.errors.push('допустимы только символы кириллицы');
            return false
          }
          // Имя
          else if (!this.arr.secInsureds[index].name) {
            this.arr.errors.push('secInsured_name' + (index + 1));
            this.arr.errors.push('укажите имя');
            return false
          } else if (!cyrillic.test(this.arr.secInsureds[index].name)) {
            this.arr.errors.push('secInsured_name' + (index + 1));
            this.arr.errors.push('допустимы только символы кириллицы');
            return false
          } else if (this.arr.secInsureds[index].name && this.arr.secInsureds[index].name === this.arr.secInsureds[index].surname) {
            this.arr.errors.push('secInsured_name' + (index + 1));
            this.arr.errors.push('одинаковые имя и фамилия недопустимы');
            return false
          }
          // Отчество
          else if (!this.arr.secInsureds[index].patronymic && !this.arr.secInsureds[index].noPatronymic) {
            this.arr.errors.push('secInsured_patronymic' + (index + 1));
            this.arr.errors.push('укажите отчество');
            return false
          } else if (this.arr.secInsureds[index].patronymic && this.arr.secInsureds[index].patronymic === this.arr.secInsureds[index].surname) {
            this.arr.errors.push('secInsured_patronymic' + (index + 1));
            this.arr.errors.push('одинаковые отчество и фамилия недопустимы');
            return false
          } else if (this.arr.secInsureds[index].patronymic && this.arr.secInsureds[index].patronymic === this.arr.secInsureds[index].name) {
            this.arr.errors.push('secInsured_patronymic' + (index + 1));
            this.arr.errors.push('одинаковые имя и отчество недопустимы');
            return false
          } else if (this.arr.secInsureds[index].patronymic && !cyrillic.test(this.arr.secInsureds[index].patronymic)) {
            this.arr.errors.push('secInsured_patronymic' + (index + 1));
            this.arr.errors.push('допустимы только символы кириллицы');
            return false
          }
          // Дата рождения
          else if (!this.arr.secInsureds[index].birth_date) {
            this.arr.errors.push('secInsured_birth_date' + (index + 1));
            this.arr.errors.push('укажите корректную дату рождения страхователя');
            return false
          } else if (this.getAge(this.arr.secInsureds[index].birth_date) > 17) {
            this.arr.errors.push('secInsured_birth_date' + (index + 1));
            this.arr.errors.push('допустимый возраст - от 0 до 17 лет');
            return false
          } else if (this.getAge(this.arr.secInsureds[index].birth_date) < 14 && this.arr.secInsureds[index].doc_type === 'passport') {
            this.arr.errors.push('secInsured_birth_date' + (index + 1));
            this.arr.errors.push('слишком малый возраст для лица с паспортом');
            return false
          }
          // Документ
          if (this.arr.secInsureds[index].doc_type === 'none') {
            this.arr.errors.push('secInsured_doc_type' + (index + 1));
            this.arr.errors.push('укажите тип документа');
            return false
          }
          // Серия
          else if (!this.arr.secInsureds[index].doc_serial) {
            this.arr.errors.push('secInsured_doc_serial' + (index + 1));
            this.arr.errors.push('укажите серию документа');
            return false
          } else if (this.arr.secInsureds[index].doc_type === 'birth_certificate' && this.arr.secInsureds[index].doc_serial.length < 3) {
            this.arr.errors.push('secInsured_doc_serial' + (index + 1));
            this.arr.errors.push('укажите серию документа полностью');
            return false
          } else if (this.arr.secInsureds[index].doc_type === 'passport' && (!passport_serial.test(this.arr.secInsureds[index].doc_serial) || this.arr.secInsureds[index].doc_serial.length !== 4)) {
            this.arr.errors.push('secInsured_doc_serial' + (index + 1));
            this.arr.errors.push('укажите серию документа (4 цифры)');
            return false
          }
          // Hомер
          else if (!this.arr.secInsureds[index].doc_number) {
            this.arr.errors.push('secInsured_doc_number' + (index + 1));
            this.arr.errors.push('укажите номер документа');
            return false
          } else if (this.arr.secInsureds[index].doc_number.length < 6) {
            this.arr.errors.push('secInsured_doc_number' + (index + 1));
            this.arr.errors.push('укажите номер документа (6 цифр)');
            return false
          }
          // Дата выдачи
          else if (!this.arr.secInsureds[index].doc_date) {
            this.arr.errors.push('secInsured_doc_date' + (index + 1));
            this.arr.errors.push('укажите дату выдачи');
            return false
          } else if (this.arr.secInsureds[index].doc_type === 'birth_certificate' && this.getAge(this.arr.secInsureds[index].birth_date) < this.getAge(this.arr.secInsureds[index].doc_date)) {
            this.arr.errors.push('secInsured_doc_date' + (index + 1));
            this.arr.errors.push('не должна быть раньше даты рождения');
            return false
          }

          // Дата выдачи - Кем выдан - Код подразделения
          else if (this.arr.secInsureds[index].doc_type === 'passport') {
            if (!this.checkDocDate(this.arr.secInsureds[index].birth_date, this.arr.secInsureds[index].doc_date)) {
              this.arr.errors.push('secInsured_doc_date' + (index + 1));
              this.arr.errors.push('укажите корректную дату выдачи (с 14 лет)');
              return false
            }
          }
        }
      }
      // Соцкарта
      if (this.str.social_card) {
        if (!cyrillicAndNums.test(this.str.social_card)) {
          this.arr.errors.push('social_card');
          this.arr.errors.push('допустимы только символы кириллицы и цифры');
          return false
        }
      }
      return true
    },
    // действия и ошибки
    unlockToOrderingBtn() {
      return this.str.contractAmount
          // && this.str.contractAmount !== 'Идет расчет...'
          && this.str.contractAmount !== '0 ₽'
          && !this.bool.contractAmountExceeded
          && (this.arr.errors[0] !== 'insurer_birth_date' || !this.bool.insurerIsInsured)
          && (this.arr.errors[0] !== 'primInsured_birth_date' || this.bool.insurerIsInsured)
    },

    unlockPolicyTerms() {
      return this.bool.newPolicyAndKidArrived && this.str.policyLink !== '#' && this.arr.errors.length === 0
    },

    unlockToPaymentBtn() {
      return this.str.selectedPackage !== 'none'
          && !this.bool.contractAmountExceeded
          && this.bool.contractAmountArrived
    },

    changeStep(item) {
      this.str.currentStep = item;
    },

    isStep(item) {
      return this.str.currentStep === item
    },

    changeTermsRisksTab(item) {
      this.str.termsRisksTab = item;
    },

    isTermsRisksTab(item) {
      return this.str.termsRisksTab === item
    },

    changePackage(item) {
      this.str.selectedPackage = item;
    },

    isPackage(item) {
      return this.str.selectedPackage === item
    },

    openDialog(type = 'server_fail') {
      this.str.dialogType = type;
      this.bool.showDialog = true;
    },

    closeDialog() {
      this.bool.showDialog = false;
    },

    maskSerial(type) {
      if (type !== 'passport') {
        return {mask: '##########', tokens: {'#': { pattern: /./ },},}
      } else {
        return {mask: '####', tokens: {'#': { pattern: /\d/ },},}
      }
    },
  },
  watch: {
    fieldsForCalc(newVal, oldVal) {
      setTimeout(() => {
        // this.arr.errors = [];
        if (this.str.selectedPackage === 'none') {
          return
        }
        if (this.bool.insurerIsInsured && (!this.obj.insurer.birth_date || this.arr.errors[0] === 'insurer_birth_date')) {
          return
        }
        if (!this.bool.insurerIsInsured && (!this.obj.primInsured.birth_date || this.arr.errors[0] === 'primInsured_birth_date')) {
          return
        }

        this.str.contractAmount = '0 ₽';
        this.calcAmount();
      }, 0);
    },
    'obj.socialCardInfo': {
      async handler() {
        if (this.bool.calcProcess) return this.bool.formIsChanged = true
        else {
          this.bool.calcProcess = true         // включаем, чтобы 1 такой запрос в момент времени
          await this.calcAmount();
          this.bool.calcProcess = false        // и выключаем, чтобы 1 такой запрос в момент времени
          if (this.bool.formIsChanged) {       // и еще проверяем была ли изменена форма за это время
            setTimeout(async() => {
              await this.calcAmount();
              this.bool.formIsChanged = false
            }, 400);
          }
        }
      },
      deep: true
    },
    validatedFields: {
      handler(val) {
        // this.arr.markedCheckboxes = [];
        this.bool.fieldsAreValidated = this.frontValidate() ? true : false;
      },
      deep: true
    },
  },
  computed: {
    fieldsForCalc() {
      if (this.bool.insurerIsInsured) {
        return `${this.str.selectedPackage}|${this.bool.transplant}|${this.str.compensateType}|${this.obj.insurer.birth_date}|${this.str.secInsuredsQuantity}|${this.obj.socialCardInfo.cardInputNumber}`;
      } else {
        return `${this.str.selectedPackage}|${this.bool.transplant}|${this.str.compensateType}|${this.obj.primInsured.birth_date}|${this.str.secInsuredsQuantity}|${this.obj.socialCardInfo.cardInputNumber}`;
      }
    },
    validatedFields() {
      const fieldsToValidate = {
        calc: this.fieldsForCalc,
        isIs: this.bool.insurerIsInsured,
        insurer: JSON.parse(JSON.stringify(this.obj.insurer)),
        primInsured: JSON.parse(JSON.stringify(this.obj.primInsured)),
        secInsureds: JSON.parse(JSON.stringify(this.arr.secInsureds)),
      }
      return fieldsToValidate;
    },
  },
  mounted() {
    this.closeDialog();
    window.document.head.getElementsByTagName('title')[0].innerHTML = 'Жизнь без границ'
    this.str.sessionToken = new Date;
    this.requestInterval();
  },
}
</script>


<style scoped lang="scss">
.required {
    span {
        color: #ff144f;
        border-color: #ff144f;
    }
}
</style>
